import React, { useState } from 'react'
import { Flex } from 'ui/acro'
import styled from 'styled-components'
import { useWindowResize } from 'hooks'
import { H5 } from 'ui/bend'
import MyEventsMobile from './MyEventsMobile'
import MyEventsCarousel from 'components_v1/EventsView/MyEventsCarousel'

const Container = styled('div')({
  marginBottom: '-82px'
})

const HLine = styled.div`
  padding: 24px 0 0 0;
  border-top: 1px solid #a3a3a3;
  margin-top: 72px;
`
const EventCount = styled.div`
  color: #3b3b3b;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  margin: 12px 0;
`

const PastEvents = ({
  events,
  totalCount,
  loadNextPageData = () => {},
  currentPage
}) => {
  const { width } = useWindowResize()
  const isMobile = width < 768
  return (
    <Container>
      <HLine />
      <H5
        as='h2'
        px={['0px']}
        mb={['16px', '16px', '16px', '24px']}
        style={{ color: '#000', fontSize: '20px', textTransform: 'uppercase' }}
      >
        Past Events
      </H5>
      {totalCount && (
        <EventCount style={{ marginBottom: '4px' }}>
          {totalCount} Events
        </EventCount>
      )}
      {isMobile ? (
        <MyEventsMobile
          events={events}
          section={'past'}
          totalCount={totalCount}
          loadNextPageData={loadNextPageData}
          currentPage={currentPage}
        />
      ) : (
        <MyEventsCarousel
          events={events}
          section={'past'}
          totalCount={totalCount}
          loadNextPageData={loadNextPageData}
          currentPage={currentPage}
          slidesPerViewOnLargeScreen={2.5}
        />
      )}
      <HLine />
    </Container>
  )
}
export default PastEvents
